import routes from "configs/routes";
import clg from "functions/log";
import React, {useState} from "react";
import { useLocation } from "react-router-dom";
import BlogSingle from "components/Blog/BlogSingle";
import MetaTags from "functions/MetaTags";
import settings from "configs/settings";

import 'assets/css/BlogSingle.min.css';

const BlogSinglePage = () => {

    const location = useLocation();
    const slug = location.pathname.split( routes.blogListings + "/" )[1];

    const [helmet, setHelmet] = useState({
        title : null,
        meta : null,
    });

    return(
        <>
        {
            (helmet.title) && (
                <MetaTags meta={ helmet.meta } title={ `${helmet.title}${settings.pageTitlePostfix}` } urlPrefix={`${window.location.origin}${(settings.onDevServer ? '/csango' : "")}${routes.blogSingle}`} />
            )
        }
        
        <BlogSingle slug={slug} setHelmet={setHelmet}/>
        </>
    )
}

export default BlogSinglePage;